<template>
  <div fluid class="pa-0 ma-0">

    <div class="background">

        <div class="d-flex justify-center pa-5" style="margin-top: 200px;">
            <div class="pt-4 mr-4">
                <v-img src="~@/assets/simplelogo.png" contain width="64"/>
            </div>
            <div class="white--text" style="font-size: 64px;">Next Level Meetings</div>
        </div>

        <div class="text-center">
            <v-btn
                large
                rounded
                color="orange"
                class="white--text"
                href="https://meetabout.it/app/index.html"
            >
                <span class="mr-2">Get Started for Free</span>
            </v-btn>
        </div>
        <v-container>
            <v-row>
                <v-col :cols="smallScreen ? 12 : mediumScreen ? 6 : 4" v-for="(card,i) in cards" :key="`card-`+i">
                    <v-card class="ma-4" height="150">
                        <v-card-title>
                            <div class="text-center" style="width: 100%;">
                                <v-icon color="warning" class="mr-2">{{card.icon}}</v-icon>    
                                {{card.title}}
                            </div>
                            
                        </v-card-title>
                        <v-card-text class="text-center" v-html="card.body"></v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <div class="product-summary text-center">
            <v-container>
                <div class="text-h2 text-center mb-10">
                    Meetings Are Where Work Gets Done
                </div>

                <span class="fa-2x">
                    <i class="fat fa-calendar-day fa-5x"></i>
                    <i class="fat fa-add fa-3x mx-10"></i>
                    <i class="fat fa-edit fa-5x"></i>
                </span>

                <div class="my-10">
                    <div class="text-h4 orange--text mt-10">Meetings are great until they aren't</div>

                    <v-row>
                        <v-col class="text-left pa-10">
                            
                            <div class="text-h5">
                                <i class="fat fa-lightbulb-exclamation fa-3x"/>
                                There is a point in almost every meeting where you wonder...
                            </div>

                            <ul class="pa-10">
                                <li class="my-5">
                                    <i>
                                        "Who was taking notes?"
                                    </i>
                                </li>
                                
                                <li class="my-5">
                                    <i>
                                        "Who is following up with who?"
                                    </i>
                                </li>

                                <li class="my-5">
                                    <i>
                                        "How do we communicate this out?"
                                    </i>
                                </li>
                            </ul>
                        </v-col>

                        <v-col class="text-left pa-10">
                            <div class="text-h5 d-flex">
                                <i class="fat fa-lightbulb-on fa-3x mr-10"/>
                                <div style="width: 500px" class="mt-1">
                                    <v-img contain src="@/assets/meetabout_logo.png"/>
                                </div>
                                
                            </div>

                            <ul class="pa-10">
                                <li class="my-5">
                                    Add agendas and topics to meetings to keep focused
                                </li>
                                
                                <li class="my-5">
                                    Assign and prioritize tasks to make sure the project keeps moving along
                                </li>

                                <li class="my-5">
                                    Apply tags to aggregate and report on topics to see how much time you are spending and where
                                </li>
                            </ul>
                        </v-col>
                    </v-row>

                </div>
            </v-container>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    computed:{
        smallScreen() {
            return this.$vuetify.breakpoint.smAndDown ? true : false
        },
        mediumScreen() {
            return this.$vuetify.breakpoint.mdAndDown ? true : false
        }
    },
    data: () => ({
        cards: [{
            title: 'Team Workflows',
            icon: 'fat fa-share-alt',
            body: 'Share Meeting Topics and Agendas'
        }, {
            title: '1:1 or Groups',
            icon: 'fat fa-user-friends',
            body: 'Work closely no matter the group size'
        }, {
            title: 'Reporting',
            icon: 'fat fa-chart-pie',
            body: 'Rich reporting shows what you are discussing and how often'
        }, {
            title: 'Quick Searching',
            icon: 'fat fa-search',
            body: 'Quickly find information from any of your meetings'
        // }, {
        //     title: 'Integrations',
        //     icon: 'fat fa-share-alt',
        //     body: 'Integrated with Google Calendar and Slack for quick communication'
        }, {
            title: 'Surveys',
            icon: 'fat fa-chart-bar',
            body: 'Meeting Effectiveness is measured with surveys.'
        }, {
            title: 'Grows With Your Team',
            icon: 'fat fa-usd-square',
            body: 'Simple pricing makes it easy to get started'
        }]
    })
  }
</script>

<style lang="scss" scoped>
.background {
    position: absolute;
    width: 100%;
    top: 0;
    height: 100%;
    overflow: hidden;
    background-image: url(~@/assets/teamBackground.jpeg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow: scroll;
}

.product-summary {
    margin-top: 200px;
    margin-bottom: 200px;
    background: white;
    padding: 80px 40px 100px 40px;
}
</style>
